export default __webpack_public_path__ + "static/media/00.98c6dd83.jpg";